exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".footer {\n  position: fixed;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  background-color: #ffffff;\n  color: #000;\n  text-align: center;\n}\n.cmsfooter-title {\n  font-family: inherit;\n}\n", ""]);

